/**
 * Sayı formatlama merkezi.
 *
 * Settings'den okunur:
 *   - quantity_decimals  → miktar ondalık sayısı (varsayılan 2)
 *   - amount_decimals    → tutar ondalık sayısı (varsayılan 2)
 *
 * Döviz kuru ondalığı SABİT 5 (kullanıcı değiştirmez).
 *
 * Kullanım:
 *   import { fmtQty, fmtAmount, fmtRate, parseLocale } from './numberFormat';
 *   fmtQty(1234.5);     // "1.234,50"
 *   fmtAmount(99.5);    // "99,50"
 *   fmtRate(0.03333);   // "0,03333"
 */

const DEFAULTS = { quantity_decimals: 2, amount_decimals: 2, rate_decimals: 5 };
const STORAGE_KEY = 'erp_format_settings';

let _state = { ...DEFAULTS };
const _listeners = new Set();

// İlk yüklemede localStorage'dan al (sayfa yenilense de hızlı)
try {
  const raw = localStorage.getItem(STORAGE_KEY);
  if (raw) _state = { ...DEFAULTS, ..._coerce(JSON.parse(raw)) };
} catch {}

function _coerce(s) {
  const n = (v, d) => {
    const x = parseInt(v);
    return Number.isFinite(x) && x >= 0 && x <= 8 ? x : d;
  };
  return {
    quantity_decimals: n(s.quantity_decimals, DEFAULTS.quantity_decimals),
    amount_decimals: n(s.amount_decimals, DEFAULTS.amount_decimals),
    rate_decimals: n(s.rate_decimals, DEFAULTS.rate_decimals),
  };
}

export function setFormatSettings(s) {
  _state = { ...DEFAULTS, ..._coerce(s || {}) };
  try { localStorage.setItem(STORAGE_KEY, JSON.stringify(_state)); } catch {}
  _listeners.forEach(fn => { try { fn(_state); } catch {} });
}

export function getFormatSettings() { return { ..._state }; }

export function onFormatChange(fn) {
  _listeners.add(fn);
  return () => _listeners.delete(fn);
}

export function getQtyDecimals()    { return _state.quantity_decimals; }
export function getAmountDecimals() { return _state.amount_decimals; }
export function getRateDecimals()   { return _state.rate_decimals; }

const _fmt = (n, decimals) => {
  const num = parseFloat(n);
  if (!Number.isFinite(num)) return Number(0).toLocaleString('tr-TR', { minimumFractionDigits: decimals, maximumFractionDigits: decimals });
  return num.toLocaleString('tr-TR', {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
    useGrouping: true,
  });
};

export function fmtQty(n)    { return _fmt(n, _state.quantity_decimals); }
export function fmtAmount(n) { return _fmt(n, _state.amount_decimals); }
export function fmtRate(n)   { return _fmt(n, _state.rate_decimals); }
export function fmtN(n, d=2) { return _fmt(n, d); }

// HTML input type=number step değeri
export function qtyStep()    { return Math.pow(10, -_state.quantity_decimals); }
export function amountStep() { return Math.pow(10, -_state.amount_decimals); }
export function rateStep()   { return Math.pow(10, -_state.rate_decimals); }

/**
 * Locale formatında girilen string'i sayıya çevir.
 *  "1.234,56" → 1234.56
 *  "1234.56"  → 1234.56  (ASCII fallback)
 */
export function parseLocale(v) {
  if (v == null || v === '') return null;
  const s = String(v).trim();
  if (!s) return null;
  // Türkçe locale: nokta binlik, virgül ondalık
  if (/[,\.]/.test(s)) {
    const last = s.lastIndexOf(',');
    const lastDot = s.lastIndexOf('.');
    let cleaned;
    if (last > lastDot) {
      cleaned = s.replace(/\./g, '').replace(',', '.');
    } else {
      cleaned = s.replace(/,/g, '');
    }
    const n = parseFloat(cleaned);
    return Number.isFinite(n) ? n : null;
  }
  const n = parseFloat(s);
  return Number.isFinite(n) ? n : null;
}
